const footerStyle = {
  footer: {
    padding: '0.9375rem 0',
    textAlign: 'center',
    position: 'fixed',
    left: '0',
    bottom: '0',
    width: '100%',
  },
};
export default footerStyle;
